<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-account-box-multiple</v-icon>
                    Clientes
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                        class="mr-4"
                        color="warning"
                        :to="{ name: 'PersonsEdit' }"
                    >
                        <v-icon left>mdi-pencil</v-icon>
                        Editar
                    </v-btn> -->
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome, CPF ou Telefone do Cliente"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
<!--                    <v-switch-->
<!--                        v-model="persons.active"-->
<!--                        :label=" `Clientes ${persons.active? 'Ativos': 'Inativos'}`"-->
<!--                        single-line-->
<!--                        hide-details-->
<!--                        class="mr-3"-->
<!--                        style="width: 220px"-->
<!--                        @change="buscar()"-->
<!--                    ></v-switch>-->
                    <v-btn
                        color="#3D1159"
                        dark
                        :to="{ name: 'personCreate' }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>

                <v-alert
                    type="warning"
                    outlined
                    v-show="!persons"
                >
                    Nenhum Cliente Encontrado
                </v-alert
                >
                
                <v-data-table
                    :headers="headers"
                    :items="filteredPersonsItems()"
                    :options.sync="options"
                    :server-items-length="persons.totalItems"
                    :search.sync="paginationOptions.search"
                    item-key="id"
                    class="elevation-1"
                    v-show="persons"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.value="{ item }">
                        {{ item.value | money }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'person', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>

                    <!--<template v-slot:item.birthdate="{ item }">
                        {{item.birthdate }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{
                                    name: 'personsEdit',
                                    params: { id: item.id }
                                }"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                    </template>-->
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {PERSON_SEARCH} from "@/store/actions/person.type";
import {PERSON_RESET_STATE, SET_PERSON_PAGINATION} from "@/store/mutations/person.type";

export default {
    name: "Persons",
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(PERSON_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.commit(PERSON_RESET_STATE),
            store.dispatch(PERSON_SEARCH)
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/persons')){
            localStorage.removeItem('personsOptions')
            localStorage.removeItem('personPaginationOptions')
        }
    },
    data: () => ({
        options: {},
        paginationOptions: {},
        headers: [
            {text: "Nome", value: "name", align: "left"},
            {text: "CPF", value: "cpf", align: "left"},
            {text: "Telefone", value: "phone", align: "left"},
            {text: "Data de Nascimento", value: "birthdate", align: "left"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],
    }),
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('personsOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('personPaginationOptions', parsed)
            },
            deep: true,
        }
    },
    methods: {
        buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            this.personPagination.search = this.paginationOptions.search

            store.commit(SET_PERSON_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            store.dispatch(PERSON_SEARCH);
        },  
        setCookie(items, value) {
            document.cookie = items + '=' + value;
        },
        filteredPersonsItems() { 
            const items = this.persons.items
            const search = this.personPagination.search ? this.personPagination.search.toLowerCase() : ""
            if(search != ''){
                this.options.itemsPerPage = this.persons.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.persons.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        }
    },
    mounted() {
        if (localStorage.getItem('personsOptions')){
            this.options = JSON.parse(localStorage.getItem('personsOptions'))
        }
        if (localStorage.getItem('personPaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('personPaginationOptions'))
        }
    },
    computed: {
        ...mapGetters(["persons", "personPagination"])
    }
};
</script>
